import React, { Component } from "react";

import Chart from "./Chart.js";
import ChartKeezle from "./ChartKeezle.js";
import moment from "moment";
import "moment/locale/ko";

export default class MonthlyChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      renderedData: null,
    };
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      renderedData: this.randerData(nextProps.selectedApp, nextProps.bizYear, nextProps.chartData),
    });
  };

  randerData = (selectedApp, bizYear, chartData) => {
    const isKeezle = selectedApp ? selectedApp.id == 'keezle' : false;
    if (bizYear && chartData) {
      var statMonthList = chartData;
      var max = 0;
      var min = 0;

      var dateArr = [];
      var newArr = [];
      var renewArr = [];
      var apOldArr = [];
      var newTerminateArr = [];
      var renewTerminateArr = [];

      var startDate = moment(
        new Date(
          `${bizYear.start}`.substring(0, 4),
          `${bizYear.start}`.substring(4, 6),
          1
        )
      ).subtract(1, "month");
      var endDate = moment(new Date(`${bizYear.end}`.substring(0, 4), 11, 1)); // {bizYear.year}-12-01
      var dataMonthLast = null;
      for (var date = startDate; date <= endDate; date = date.add(1, "month")) {
        dateArr.push(date.format("YY-MM"));

        var month = date.format("YYYYMM");
        if(isKeezle) {
          dataMonthLast = null;
        }
        const dataMonth = statMonthList
          ? statMonthList.find((m) => m.month == month)
          : null;
        const countApNew = dataMonth
          ? dataMonth.countApNew -
            (dataMonthLast ? dataMonthLast.countApNew : 0)
          : 0;
        const countApRe = dataMonth
          ? (dataMonth.countApRe || 0) - (dataMonthLast ? dataMonthLast.countApRe || 0 : 0)
          : 0;
        const countApOld = dataMonth
          ? (dataMonth.countApOld || 0) - (dataMonthLast ? dataMonthLast.countApOld || 0 : 0)
          : 0;
        const countNaNew = dataMonth
          ? dataMonth.countNaNew -
            (dataMonthLast ? dataMonthLast.countNaNew : 0)
          : 0;
        const countNaRe = dataMonth
          ? dataMonth.countNaRe - (dataMonthLast ? dataMonthLast.countNaRe : 0)
          : 0;

        newArr.push(countApNew);
        renewArr.push(countApRe);
        apOldArr.push(countApOld);
        newTerminateArr.push(countNaNew);
        renewTerminateArr.push(countNaRe);

        if (max < countApNew + countApRe + countApOld) max = countApNew + countApRe + countApOld;
        if (month == bizYear.end) {
          dataMonthLast = null;
        } else {
          dataMonthLast = dataMonth;
        }
      }

      max = Math.ceil(max / 10) * 10 + 10;
      min = 0;

      var result = {
        max: max,
        min: min,
        dateArr: dateArr,
        newArr: newArr,
        renewArr: renewArr,
        apOldArr: apOldArr,
        newTerminateArr: newTerminateArr,
        renewTerminateArr: renewTerminateArr,
      };

      return result;
    } else {
      return null;
    }
  };

  render() {
    if (this.props.chartData == null) {
      return (
        <div className="card border-top border-3 border-top-danger">
          <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
            <h4 className="card-header-title">월별 계약</h4>
          </div>
          <div
            className="card-body"
            style={{
              height: this.props.height + "px",
              textAlign: "center",
              paddingTop: "50px",
            }}
          >
            <span className="dashboard-spinner spinner-xxl"></span>
          </div>
        </div>
      );
    } else if (this.props.chartData == null) {
      return (
        <div className="card border-top border-3 border-top-danger">
          <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
            <h4 className="card-header-title">월별 계약</h4>
          </div>
          <div
            className="card-body"
            style={{ height: this.props.height + "px" }}
          >
            No Data
          </div>
        </div>
      );
    } else {
      const isKeezle = this.props.selectedApp ? this.props.selectedApp.id == 'keezle' : false;
      return (
        <div className="card">
          <div className="card-header d-flex" style={{ padding: "5px 20px" }}>
            <h4 className="card-header-title">{`월별 계약 - ${this.props.bizYear.year}년`}</h4>
          </div>
          <div
            className="card-body"
            style={{ height: this.props.height + "px" }}
          >
            {!isKeezle && <Chart selectedApp={this.props.selectedApp} data={this.state.renderedData} />}
            {isKeezle && <ChartKeezle selectedApp={this.props.selectedApp} data={this.state.renderedData} />}
          </div>
        </div>
      );
    }
  }
}
